export default __webpack_public_path__ + "static/media/Banner.d475bcd5.png";